import React from 'react'
import { Badge, Tag, Space, Typography } from 'antd'

const { Text } = Typography

// Get status badge for bed status
export const getStatusBadge = (status) => {
  switch (status) {
    case 'Occupied':
      return <Badge status='error' text='Occupied' />
    case 'Available':
      return <Badge status='success' text='Available' />
    case 'Cleaning':
      return <Badge status='processing' text='Cleaning' />
    default:
      return <Badge status='default' text={status} />
  }
}

// Format patient information with name and ID
export const formatPatientInfo = (patient, patientId) => {
  return patient ? (
    <Space>
      <Text>{patient}</Text>
      <Tag color='blue'>{patientId}</Tag>
    </Space>
  ) : (
    '-'
  )
}

// Calculate time remaining until expected availability
export const getTimeRemaining = (bed) => {
  if (bed.bedStatus !== 'Occupied' || !bed.expectedAvailability) return null

  const now = new Date()
  const availability = new Date(bed.expectedAvailability)
  const diffTime = availability - now

  if (diffTime <= 0) return 'Due for discharge'

  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
  const diffHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))

  if (diffDays > 0) {
    return `${diffDays}d ${diffHours}h`
  } else {
    return `${diffHours}h`
  }
}

// Format time remaining for display
export const formatTimeRemaining = (timeRemaining) => {
  if (!timeRemaining) return '-'

  return <Tag color={timeRemaining === 'Due for discharge' ? 'red' : 'orange'}>{timeRemaining}</Tag>
}

// Format occupancy rate with color-coded tag
export const formatOccupancyRate = (rate) => {
  return <Tag color={rate > 90 ? 'red' : rate > 75 ? 'orange' : 'green'}>{rate}%</Tag>
}
